import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { Home, Heart, UserRound, Briefcase } from "lucide-react";
import { motion } from "framer-motion";

const navItems = [
  { to: "/dashboard", icon: Home, label: "Home" },
  { to: "/collections", icon: Heart, label: "Likes" },
  { to: "/portals", icon: Briefcase, label: "Portals" },
  { to: "/profile", icon: UserRound, label: "Profile" },
];

const BottomNav = () => {
  const location = useLocation();

  return (
    <nav className="fixed bottom-6 left-1/2 -translate-x-1/2 z-50 glass rounded-full flex items-center p-1.5 w-[92%] max-w-sm shadow-2xl border border-white/20 dark:border-white/10 transition-all duration-500">
      <div className="flex justify-between w-full relative">
        {navItems.map(({ to, icon: Icon, label }) => {
          const isActive = location.pathname === to;

          return (
            <NavLink
              key={to}
              to={to}
              className="relative flex-1 flex flex-col items-center justify-center py-2.5 px-1 rounded-full transition-all duration-300 z-10"
            >
              {isActive && (
                <motion.div
                  layoutId="activePill"
                  className="absolute inset-0 bg-slate-900 dark:bg-white rounded-full shadow-lg"
                  transition={{ type: "spring", bounce: 0.25, duration: 0.5 }}
                />
              )}

              <Icon
                className={`w-5 h-5 mb-0.5 transition-all duration-300 z-20 ${isActive ? "text-white dark:text-slate-900 scale-110" : "text-slate-400 dark:text-slate-500"
                  }`}
                strokeWidth={isActive ? 2.5 : 2}
              />

              <span className={`text-[9px] font-bold uppercase tracking-widest transition-all duration-300 z-20 ${isActive ? "text-white dark:text-slate-900" : "text-slate-400 dark:text-slate-500 opacity-70"
                }`}>
                {label}
              </span>
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
};

export default BottomNav; 